/**
 * Scientific Validation — frontend behaviour.
 *
 * Loaded as a native ES module ONLY on pages where this block renders. The
 * first import pulls in this section's CSS so it ships as one isolated bundle.
 *
 * Blur-reveal for the head, then a staggered reveal for the grid cards.
 */
import './style.scss';
import { gsap } from 'gsap';

function init() {
	const sections = document.querySelectorAll('[data-scival]');
	if (!sections.length) return;

	const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

	sections.forEach((section) => {
		const head = section.querySelectorAll('[data-scival-anim]');
		const cards = section.querySelectorAll('[data-scival-card]');
		const targets = [...head, ...cards];
		if (!targets.length) return;

		if (reduced) {
			targets.forEach((el) => { el.style.opacity = '1'; el.style.transform = 'none'; });
			return;
		}

		gsap.set(targets, { opacity: 0, y: 24, filter: 'blur(10px)' });

		const io = new IntersectionObserver((entries) => {
			entries.forEach((entry) => {
				if (!entry.isIntersecting) return;
				io.unobserve(entry.target);
				gsap.timeline()
					.to(head, {
						opacity: 1, y: 0, filter: 'blur(0px)',
						duration: 0.7, ease: 'power3.out', stagger: 0.1,
						clearProps: 'transform',
					})
					.to(cards, {
						opacity: 1, y: 0, filter: 'blur(0px)',
						duration: 0.7, ease: 'power3.out', stagger: 0.08,
						// clearProps so GSAP's leftover inline transform doesn't
						// pin the card and break the CSS :hover lift.
						clearProps: 'transform',
					}, '-=0.35');
			});
		}, { rootMargin: '0px 0px -15% 0px', threshold: 0.1 });

		io.observe(section);
	});
}

if (document.readyState !== 'loading') init();
else document.addEventListener('DOMContentLoaded', init);
